import { Title } from 'library/styles/text';
import { getBrowserInfo, getOSInfo } from 'library/helpers/system';
import {
  Container,
  InfoText,
  Info,
  IconContainer,
  Icon,
  IconText,
  Line,
  TextContainer,
} from './styles';

const AboutSupport = ({
  version, itemCount, syncVersion, user,
}) => {
  const emailBody = `User:%20${user?.email}%0AApp Version:%20${version}%0ABrowser:%20${getBrowserInfo()}%0AOS:%20${getOSInfo()}%0A`;
  const emailHref = `mailto:support@colormylife.com?subject=Web%20support%20&body=${emailBody}`;

  return (
    <Container>
      <Title>About & support</Title>
      <TextContainer>
        <InfoText>
          {`App version: ${version}`}
        </InfoText>
        {
          syncVersion ? (
            <InfoText>
              {`Sync version: ${syncVersion}`}
            </InfoText>
          ) : null
        }
        <InfoText>
          {`Number of items: ${itemCount}`}
        </InfoText>
      </TextContainer>
      <Line />
      <Info
        href={emailHref}
      >
        <IconContainer>
          <Icon className="icon-envolope" />
        </IconContainer>
        <IconText>support@colormylife.com</IconText>
      </Info>
      <Line />
      <TextContainer>
        <InfoText>
          Copyright ©
          {new Date().getFullYear()}
          {' '}
          Color My Life, Inc.
        </InfoText>
        <InfoText>Color My Life ®</InfoText>
      </TextContainer>
    </Container>
  );
};

export default AboutSupport;
